/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Discriminator {
  WAGE_TYPE = 'WAGE_TYPE',
  EMPLOYMENT_TYPE = 'EMPLOYMENT_TYPE',
  NONE = 'NONE',
}
